import {File, FILES_API_PATH, Quote, QuoteApi, PaymentMode, SupplierQuote} from "@betrue/shared/interfaces";
import {useState} from "react";
import {gql, useLazyQuery, useMutation} from "@apollo/client";
import {useResult} from "./results";
import {CORE_FILE_FIELDS} from "./file.service";
import {BASE_ENTITY_FIELDS} from "./base-fields";
import {CONFIG} from "@betrue/ui";

export const CORE_QUOTE_FIELDS = gql`
  ${CORE_FILE_FIELDS}
  fragment CoreQuoteFields on SupplierQuoteModel{
    ${BASE_ENTITY_FIELDS}
    amount
    amountUntaxed
    quoteDate
    state
    reference
    file {
      ...CoreFileField
    }
    submitter {
      ${BASE_ENTITY_FIELDS}
      stripeAccountId
      firstName
      lastName
    }
  }
`


const CREATE_SUPPLIER_QUOTE = gql`
  ${CORE_QUOTE_FIELDS}
  mutation createSupplierQuote($supplierQuote: SupplierQuoteModelInput!) {
    createSupplierQuote(supplierQuote: $supplierQuote) {
      ...CoreQuoteFields
    }
  }
`

const GET_SUPPLIER_QUOTES =
gql`
  ${CORE_QUOTE_FIELDS}
  query supplierQuotes($supplierId: String!){
    supplierQuotes(supplierId: $supplierId){
      ...CoreQuoteFields
    }
  }
`

const DELETE_SUPPLIER_QUOTE =
gql`
  ${CORE_QUOTE_FIELDS}
  query deleteSupplierQuote($id: String!){
    deleteSupplierQuote(id: $id){
      ...CoreQuoteFields
    }
  }

`

const ACCEPT_SUPPLIER_QUOTE =
gql`
  ${CORE_QUOTE_FIELDS}
  mutation acceptSupplierQuote($id: String!){
    acceptSupplierQuote(id: $id){
      ...CoreQuoteFields
    }
  }

`


const DECLINE_SUPPLIER_QUOTE =
gql`
  ${CORE_QUOTE_FIELDS}
  mutation declineSupplierQuote($id: String!){
    declineSupplierQuote(id: $id){
      ...CoreQuoteFields
    }
  }

`

const FIND_ALL =
gql`
  ${CORE_QUOTE_FIELDS}
  query findAll{
    findAllQuotes {
      ...CoreQuoteFields
    }
  }

`

export const useQuote = <T = Quote | Quote[]>(): [T, QuoteApi] => {
  const [result, setResult] = useState<T>();
  const createSupplierQuote = useResult(useMutation(CREATE_SUPPLIER_QUOTE), setResult)
  const supplierQuotes = useResult(useLazyQuery(GET_SUPPLIER_QUOTES, {fetchPolicy: 'cache-and-network'}), setResult)
  const deleteSupplierQuote = useResult(useLazyQuery(DELETE_SUPPLIER_QUOTE, {fetchPolicy: 'cache-and-network'}), setResult)
  const acceptSupplierQuote = useResult(useMutation(ACCEPT_SUPPLIER_QUOTE), setResult)
  const declineSupplierQuote = useResult(useMutation(DECLINE_SUPPLIER_QUOTE), setResult)

  const findAll = useResult(useLazyQuery(FIND_ALL, {fetchPolicy: 'cache-and-network'}), setResult)

  return [
    result,
    {
      findAllQuotes() {
        findAll({})
      },
      acceptSupplierQuote(id: string) {
        acceptSupplierQuote({
          variables: {
            id: id
          }
        })
      },
      declineSupplierQuote(id: string) {
        console.log('id', id)
        declineSupplierQuote({
          variables: {
            id: id
          }
        })
      },
      deleteSupplierQuote(id: string) {
        deleteSupplierQuote({
            variables: {
              id: id
            }
          }
        )

      },
      createSupplierQuote(supplierQuote: SupplierQuote) {
        createSupplierQuote({
          variables: {
            supplierQuote: {...supplierQuote}
          }
        })
      },
      supplierQuotes(supplierId: string) {
        supplierQuotes({
          variables: {
            supplierId: supplierId
          }
        })
      }
    }]
}

